import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';


import {
  IApplication,
  IApplicationInput,
  IApprovalTask,
  IHelp,
  HelpApiService
} from '@ebb-v2/ebb-integration';
import { Console } from 'console';
import { cloneDeep } from 'lodash';
import { DialogConfirmMessageComponent } from '../dialog/dialog-confirm-message.component';
import { MatRadioChange } from '@angular/material/radio';

@Component({
    selector: 'ebb-portal-contractor-sg-form',
    templateUrl: './contractor-sg-form.component.html',
    standalone: false
})
export class ContractorSgFormComponent implements OnInit {
  @Input() set application(value: IApplication) {
    this.applicationData = value;
    this.bidInvoiceNeeded = value.sGBidInvoiceNeeded;
    
    if (value && this.formBidInvoiceInfo) {

      //If homeowner has not yet explicitly chosen yes or no, set to null.
      //Else, use homeowner choice.
      this.formBidInvoiceInfo.controls['bidInvoiceNeeded'].setValue(
        value.sGBidInvoiceNeededHomeowner !== true
        ?
        null
        :
        value.sGBidInvoiceNeeded === true
        ?
        'yes'
        :
        'no'
      );

      this.formBidInvoiceInfoPriorValue = this.formBidInvoiceInfo.controls['bidInvoiceNeeded'].value;
      this.emitBidInvoiceChoiceEvent.emit(this.formBidInvoiceInfoPriorValue === null ? false : true);

      //prevent user from losing their cost update if update file
      const currentCostValue = this.formBidInvoiceInfo.controls['bidInvoiceCost'].value;
      
      if (this.bidInvoiceNeeded && !currentCostValue) {
        this.formBidInvoiceInfo.controls['bidInvoiceCost'].setValue(value.bidInvoiceCost);
      }

      //disable if invoice is submitted for payment
      if (this.applicationData.sGBidInvoiceSubmitted === 1) {
        this.sgBidSubmitted = true;
        this.formBidInvoiceInfo.disable();
      //disable if submitted for preliminary review (not rejected)
      } else if (this.applicationData.stageCode === 700000000 &&
        (this.applicationData.eventPreliminaryReview !== true ||
        this.applicationData.applicationStatusOptionSet === 'Preliminary Review Rejected')) {
        this.sgBidSubmitted = false;
        this.formBidInvoiceInfo.enable();
      } else {
        this.sgBidSubmitted = false;
        this.formBidInvoiceInfo.disable();
      }
    }
  }
  @Input() set taskSG(value: IApprovalTask) {
    this.taskSgFiltered = cloneDeep(value) as IApprovalTask;
    this.loading = false;
    this.taskSgFiltered.approvalTaskItems =
      this.taskSgFiltered.approvalTaskItems.filter(x => x.payloadTypeCode === 700000000 && x.name =='Invoice for receiving a Bid'); //payload type of file
    if (this.formBidInvoiceInfo) {
      const taskItem = 
        this.taskSgFiltered.approvalTaskItems.length > 0 
        ? this.taskSgFiltered.approvalTaskItems[0] 
        : undefined;
      this.formBidInvoiceInfo.controls['bidInvoiceFileAttached'].setValue(
        taskItem && 
        taskItem.payload && 
        (taskItem.statusCode === 700000000 || taskItem.statusCode === 700000003)
      );
    }
  }
  @Input('w9Shown') w9Shown: boolean;
  @Output() emitContractorUpdateEvent = new EventEmitter<IApplicationInput>();
  @Output() emitFileUploadEvent = new EventEmitter<IApprovalTask>();
  @Output() emitBidInvoiceApplicationChangeEvent = new EventEmitter<IApplicationInput>();
  @Output() emitBidInvoiceChoiceEvent = new EventEmitter<boolean>();

  public listHelp: IHelp[] = [];
  public textBidInvoiceFileIntroSgHelpText = '';
  public textBidInvliceCostIntroSgHelpText = '';
  public taskSgFiltered: IApprovalTask;
  public applicationData: IApplication;
  public sgBidSubmitted = true;
  public loading = false;
  public formBidInvoiceInfo: FormGroup;
  public bidInvoiceNeeded: boolean;
  public formBidInvoiceInfoPriorValue: string;

  constructor(
    private readonly apiHelp: HelpApiService,
    private readonly dialogConfirmSubmit: MatDialog,
    private _fb: FormBuilder,
  ) {
    this.bidInvoiceNeeded = false;
    this.formBidInvoiceInfo = this._fb.group({
      bidInvoiceCost: [null,
        [
          Validators.required,
          Validators.min(1),
          Validators.max(250)
        ]
      ],
      bidInvoiceNeeded: [null,
        [
          Validators.required
        ]
      ],
      bidInvoiceFileAttached: [null,
        [
          Validators.requiredTrue
        ]
      ]
    });
  }

  ngOnInit() {
    this.loadHelpText();
  }

  private loadHelpText(): void {
    this.apiHelp.setCurrentHelpTopicValue('Construction');
    this.apiHelp
      .getList()
      .subscribe(
        data => {
          this.listHelp = JSON.parse(JSON.stringify(data));
          const indexBidInvoiceFileIntroSgHelpText = this.listHelp.findIndex(i => i.name.toLowerCase() === 'sgbidinvoicefileintro');
          this.textBidInvoiceFileIntroSgHelpText = this.listHelp[indexBidInvoiceFileIntroSgHelpText] ? this.listHelp[indexBidInvoiceFileIntroSgHelpText].answer : 'content missing: sgbidinvoicefileintro';

          const indexBidInvliceCostIntroSgHelpText = this.listHelp.findIndex(i => i.name.toLowerCase() === 'sgbidinvoicecostintro');
          this.textBidInvliceCostIntroSgHelpText = this.listHelp[indexBidInvliceCostIntroSgHelpText] ? this.listHelp[indexBidInvliceCostIntroSgHelpText].answer : 'content missing: sgbidinvoicecostintro';
        },
        error => console.log(error)
      );
  }

  onChangeEventBidInvoice($event: MatRadioChange ) {
    this.emitBidInvoiceChoiceEvent.emit(true);
    if ($event.value === 'no' && this.applicationData.sGBidInvoiceNeededHomeowner === true) {
      const dialogViewDataItem = {
        title: 'Bid Invoice',
        message: 'Are you sure you want to cancel? All information for your bid invoice will be lost.',
        buttonCancelLabel:'No',
        buttonlabel:'Yes' };
      const dialogRefConfirm = this.dialogConfirmSubmit.open(
        DialogConfirmMessageComponent,
        { width: '400px', data: dialogViewDataItem }
      );
      dialogRefConfirm.afterClosed().subscribe(result => {
        if (result === 1) {
          this.formBidInvoiceInfo.controls['bidInvoiceNeeded'].disable();
          this.bidInvoiceNeeded = false;
          const applicationUpdate: IApplicationInput = {} as IApplicationInput;
          applicationUpdate.sGBidInvoiceNeeded = false;
          applicationUpdate.sGBidInvoiceNeededHomeowner = true;
          this.emitBidInvoiceApplicationChangeEvent.emit(applicationUpdate);
          this.loading = true;
        } else {
          this.formBidInvoiceInfo.controls['bidInvoiceNeeded'].setValue('yes');
        }
      });
    } else if ($event.value === 'yes') {
        this.bidInvoiceNeeded = $event.value === 'yes';
        this.formBidInvoiceInfo.controls['bidInvoiceNeeded'].disable();
        const applicationUpdate: IApplicationInput = {} as IApplicationInput;
        applicationUpdate.sGBidInvoiceNeeded = (this.formBidInvoiceInfo.controls['bidInvoiceNeeded'].value === 'yes' ? true : false);
        applicationUpdate.sGBidInvoiceNeededHomeowner = true;
        applicationUpdate.bidInvoiceCost = this.formBidInvoiceInfo.controls['bidInvoiceCost'].value;
        this.emitBidInvoiceApplicationChangeEvent.emit(applicationUpdate);
        this.loading = true;
    } else {
      const applicationUpdate: IApplicationInput = {} as IApplicationInput;
      applicationUpdate.sGBidInvoiceNeededHomeowner = true;
      this.emitBidInvoiceApplicationChangeEvent.emit(applicationUpdate);
  }
    this.formBidInvoiceInfoPriorValue = $event.value;
  }

  onClickSaveBidInvoiceInfo() {
    if(this.formBidInvoiceInfo.valid) {
      
      //alert popup only if W-9 is not complete
      if(this.w9Shown && !this.applicationData.w9DataSubmitted) {
        const dialogViewDataItem = {
          title: 'W-9 Form',
          message: 'To be paid for your bid invoice as soon as possible, please complete the W-9 section.',
          buttonlabel:'OK' };
        const dialogRefConfirm = this.dialogConfirmSubmit.open(
          DialogConfirmMessageComponent,
          { width: '400px', data: dialogViewDataItem }
        );
      }

      const applicationUpdate: IApplicationInput = {} as IApplicationInput;
      applicationUpdate.sGBidInvoiceNeeded = (this.formBidInvoiceInfo.controls['bidInvoiceNeeded'].value === 'yes' ? true : false);
      applicationUpdate.sGBidInvoiceSubmitted = 1;
      applicationUpdate.bidInvoiceCost = Number(this.formBidInvoiceInfo.controls['bidInvoiceCost'].value);
      this.sgBidSubmitted = true;
      this.formBidInvoiceInfo.disable();
      this.emitBidInvoiceApplicationChangeEvent.emit(applicationUpdate);
    }
  }

  onEmitFileUploadEvent($event: IApprovalTask) {
    this.emitFileUploadEvent.emit($event);
  }

  checkBidInvoiceFormLock() : boolean{
    return !this.formBidInvoiceInfo.valid;
  }

}


